import React, { useEffect } from "react";
import { useState } from "react";
// import validator from 'validator'
import { localUrl, url } from "../../env";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { add } from "../../../store/Track/trackUserSlice";
import { Button } from "@mui/material";
// import { FaBullseye } from 'react-icons/fa';
const ForgotPassword = (props) => {
  var idChecking = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [idCheckingLoading, setidCheckingLoading] = useState(
    idChecking?.id ? true : false
  );
  const [afterSuccess, setafterSuccess] = useState(false);
  const [passwordError, setPasswordError] = useState({
    password: "",
    password2: "",
  });

  const dispatch = useDispatch();
  // if(props?.id){
  //   debugger

  // // }

  // if(){
  //   setidCheckingLoading(true)
  // }

  // useEffect(()=>{
  //   if(idCheckingLoading){
  //     console.log("verifying linking ")
  //   }

  // },[])
  const [loginform, setloginform] = useState({
    emailPhoneUser: "",
  });

  const [resetpassword, setresetpassword] = useState({
    password: "",
    password2: "",
  });
  const [SuccessLinksend, setSuccessLinksend] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleChangeRest = (e) => {
    var name = e.target.name;
    var value = e.target.value;
    setresetpassword({ ...resetpassword, [name]: value });
  };

  const handleSubmitReset = (e) => {
    e.preventDefault();
    if (resetpassword.password == "") {
      setPasswordError({ password: "password field is required" });

      console.log(passwordError.password);

      return;
    } else if (resetpassword.password2 == "") {
      setPasswordError({ password2: "confirm password is required" });

      console.log(passwordError.password2);

      return;
    }else {
   
    var formdata = new FormData();
    formdata.append("password", resetpassword.password);
    formdata.append("password2", resetpassword.password2);

    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    fetch(
      url +
        "api/user/reset-password/" +
        idChecking?.uid +
        "/" +
        idChecking?.id +
        "/",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result?.errors?.non_field_errors) {
          setError(result?.errors?.non_field_errors);
        } else {
          setafterSuccess(true);
          setTimeout(() => {
            navigate("/login/");
          }, 2000);
        }
      })
      .catch((error) => console.log("error", error));
  };
     
}

  //calling email verification

  const handleChange = (e) => {
    var name = e.target.name;
    var value = e.target.value;
    setError(false)
    setloginform({ ...loginform, [name]: value });
    console.log("@@checking contactform value", loginform);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    var formdata = new FormData();
    formdata.append("email", loginform.emailPhoneUser);

    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    fetch(url + "api/user/send-reset-password-email/", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result?.errors?.email) {
          setError(result?.errors?.email[0]);
        } else if (result?.errors?.non_field_errors) {
          setError(result?.errors?.non_field_errors);
        } else {
          setSuccessLinksend(true);
        }
      });
  };
  useEffect(() => {
    dispatch(add({ view: ["ForgotPassword"] }));
  }, []);

  return (
    <>
      <div className="row p-4">
        <div
          className="col-lg-4 col-md-4 col-sm-12 mt-5 mb-5"
          style={{
            border: "1px solid white",
            margin: "auto",
            boxShadow: "0px 5px 10px 0px rgba(0,0,0,0.5)",
            borderRadius: "5px",
          }}
        >
          <div className="contact-form">
            <h2 className="fs-18 text-center">login with email</h2>
            {!afterSuccess ? (
              !idChecking?.id ? (
                !SuccessLinksend ? (
                  <form
                  style={{marginBottom:'30px'}}
                    action="/contact/"
                    method="POST"
                    className="form-underline"
                  >
                    <div className="field-inline">
                      <div
                        className="field-input"
                        style={{ marginTop: "-10px" }}
                      >
                        <input
                          style={{ width: "200%" }}
                          type="email"
                          id="emailPhoneUser"
                          name="emailPhoneUser"
                          value={loginform.emailPhoneUser}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="username or email "
                        />
                      </div>
                    </div>
                    {loading?<div className="loader"></div> :
                    <Button style={{color:'white'}} className="btn btn-primary"
                      type="submit" variant="outlined"
                      onClick={handleSubmit}
                    >
                      <span>Submit</span>
                    </Button>
                    }
                    {success ? (
                      <div className="text-success">{success}</div>
                    ) : null}
                    {error ? <div className="text-danger" style={{position:'absolute'}}>{error}</div> : null}
                  </form>
                ) : (
                  <div
                    className="text-center"
                    style={{ color: "green", marginTop: "-20px" }}
                  >
                    Link has been sent successfully{" "}
                  </div>
                )
              ) : (
                <div>
                  <form
                    action="/contact/"
                    method="POST"
                    className="form-underline"
                  >
                    <div className="field-inline">
                      <div className="field-input">
                        <input
                          style={{ width: "200%" }}
                          type="text"
                          id="password"
                          name="password"
                          value={resetpassword.password}
                          onChange={handleChangeRest}
                          className="form-control"
                          placeholder="Password  "
                        />
                        {passwordError.password !== '' && <p style={{color:"red"}}>{passwordError.password}</p>}
                      </div>
                    </div>

                    <div className="field-inline">
                      <div className="field-input">
                        <input
                          style={{ width: "200%" }}
                          type="text"
                          id="password2"
                          name="password2"
                          value={resetpassword.password2}
                          onChange={handleChangeRest}
                          className="form-control"
                          placeholder="Confirm Password"
                        />
                        <p style={{color:"red"}}>{passwordError.password2}</p>
                      </div>
                    </div>

                    {/* <button type="submit" onClick={handleSubmit} className="btn btn-primary">
                             submit
                           </button> */}
                           <Button
                      type="submit" variant="outlined"
                      onClick={handleSubmitReset}
                      className=""
                    >
                      <span>Submit</span>
                    </Button>
                    {success ? (
                      <div className="text-success">{success}</div>
                    ) : null}
                    {error ? <div className="text-danger">{error}</div> : null}
                  </form>
                </div>
              )
            ) : (
              <div
                className="text-center"
                style={{ color: "green", marginTop: "-20px" }}
              >
                Password successfully changed{" "}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
